const FUNNEL_RETURN_PATH = "/landingwithnewcrew";

export function getFunnelPlannerDestination(isAuthenticated: boolean): string {
  const plannerPath = `/create-trip?returnTo=${encodeURIComponent(FUNNEL_RETURN_PATH)}`;
  return isAuthenticated
    ? plannerPath
    : `/sign-in?returnTo=${encodeURIComponent(plannerPath)}`;
}